import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePanelConfig } from '../../../modules/panel';
import { useDragHandler } from '../../../utils/useDragHandler';
import { resetDefaults as resetPanelDetailDefaults } from '../../../redux/panelDetailSlice';
import { resetBaslikDefaults } from '../../../redux/baslikSlice';
import PanelTypesTab from './tabs/PanelTypesTab';
import OutputTypesTab from './tabs/OutputTypesTab';
import HierarchyTab from './tabs/HierarchyTab';
import PanelDetailTab from './tabs/PanelDetailTab';
import BaslikTab from './tabs/BaslikTab';
import DrawingTab from './tabs/DrawingTab';

const MAIN_TABS = [
  { id: 'paneller', label: 'Paneller' },
  { id: 'panoDetay', label: 'Pano Detaylar' },
  { id: 'baslik', label: 'Baslik' },
  { id: 'drawing', label: 'Drawing' },
];

const PANEL_SUB_TABS = [
  { id: 'panelTypes', label: 'Panel Tipleri' },
  { id: 'outputTypes', label: 'Cikis Tipleri' },
  { id: 'hierarchy', label: 'Hiyerarsi' },
];

export default function PanelSettingsPopup({ onClose }) {
  const [activeMainTab, setActiveMainTab] = useState('paneller');
  const [activeSubTab, setActiveSubTab] = useState('panelTypes');
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const { resetToDefaults } = usePanelConfig();
  const dispatch = useDispatch();

  const { handleMouseDown } = useDragHandler((dx, dy) => {
    setPosition(prev => ({ x: prev.x + dx, y: prev.y + dy }));
  });

  const handleReset = () => {
    resetToDefaults();
    dispatch(resetPanelDetailDefaults());
    dispatch(resetBaslikDefaults());
  };

  const handleSave = () => {
    onClose();
  };

  const handleHeaderMouseDown = (e) => {
    e.stopPropagation();
    handleMouseDown(e);
  };

  return (
    <div className="settings-popup-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}>
      <div
        className="settings-popup"
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="settings-popup-header"
          style={{ cursor: 'move', userSelect: 'none' }}
          onMouseDown={handleHeaderMouseDown}
        >
          Ayarlar
          <button
            className="close-button"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        {/* Ana Tab Bar */}
        <div className="tab-bar">
          {MAIN_TABS.map(tab => (
            <button
              key={tab.id}
              className={`tab-bar-item ${activeMainTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveMainTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Paneller alt tabları */}
        {activeMainTab === 'paneller' && (
          <div className="tab-bar sub-tab-bar">
            {PANEL_SUB_TABS.map(tab => (
              <button
                key={tab.id}
                className={`tab-bar-item sub-tab-item ${activeSubTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveSubTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        {/* Tab Content */}
        <div className="tab-content">
          {activeMainTab === 'paneller' && activeSubTab === 'panelTypes' && <PanelTypesTab />}
          {activeMainTab === 'paneller' && activeSubTab === 'outputTypes' && <OutputTypesTab />}
          {activeMainTab === 'paneller' && activeSubTab === 'hierarchy' && <HierarchyTab />}
          {activeMainTab === 'panoDetay' && <PanelDetailTab />}
          {activeMainTab === 'baslik' && <BaslikTab />}
          {activeMainTab === 'drawing' && <DrawingTab />}
        </div>

        {/* Footer */}
        <div className="settings-footer">
          <button className="settings-btn" onClick={handleReset}>
            Varsayılana Dön
          </button>
          <button className="settings-btn settings-btn-primary" onClick={handleSave}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
}
